import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../../lib/utils';
const bottleStatusMap = {
    pending_arrival: { label: 'Pending Arrival', className: 'bg-yellow-100 text-yellow-800' },
    in_stock: { label: 'In Stock', className: 'bg-green-100 text-green-800' },
    opened: { label: 'Opened', className: 'bg-blue-100 text-blue-800' },
    drunk: { label: 'Drunk', className: 'bg-gray-100 text-gray-700' },
    gifted: { label: 'Gifted', className: 'bg-purple-100 text-purple-800' },
    sold: { label: 'Sold', className: 'bg-orange-100 text-orange-800' },
    spoiled: { label: 'Spoiled', className: 'bg-red-100 text-red-800' },
    lost: { label: 'Lost', className: 'bg-red-100 text-red-800' },
    donated: { label: 'Donated', className: 'bg-teal-100 text-teal-800' },
};
export function BottleStatusBadge({ status, className }) {
    const config = bottleStatusMap[status] ?? { label: status, className: 'bg-gray-100 text-gray-700' };
    return (_jsx("span", { className: cn('badge', config.className, className), children: config.label }));
}
const maturityStateMap = {
    too_young: { label: 'Too Young', className: 'bg-blue-100 text-blue-800' },
    approaching_window: { label: 'Approaching', className: 'bg-sky-100 text-sky-800' },
    entering_window: { label: 'Entering Window', className: 'bg-teal-100 text-teal-800' },
    drink_now: { label: 'Drink Now', className: 'bg-emerald-100 text-emerald-800' },
    mature: { label: 'Mature', className: 'bg-green-100 text-green-800' },
    at_peak: { label: 'At Peak', className: 'bg-emerald-100 text-emerald-800' },
    fully_mature: { label: 'Fully Mature', className: 'bg-lime-100 text-lime-800' },
    declining: { label: 'Declining', className: 'bg-amber-100 text-amber-800' },
    past_it: { label: 'Past It', className: 'bg-red-100 text-red-800' },
    unknown: { label: 'Unknown', className: 'bg-gray-100 text-gray-500' },
};
export function MaturityStateBadge({ status, className }) {
    const config = maturityStateMap[status] ?? { label: status, className: 'bg-gray-100 text-gray-500' };
    return (_jsx("span", { className: cn('badge', config.className, className), children: config.label }));
}
const caseIntegrityMap = {
    intact: { label: 'Intact', className: 'bg-green-100 text-green-800' },
    partially_split: { label: 'Partially Split', className: 'bg-amber-100 text-amber-800' },
    fully_split: { label: 'Fully Split', className: 'bg-red-100 text-red-800' },
    not_applicable: { label: 'N/A', className: 'bg-gray-100 text-gray-500' },
};
export function CaseIntegrityBadge({ status, className }) {
    const config = caseIntegrityMap[status] ?? { label: status, className: 'bg-gray-100 text-gray-500' };
    return (_jsx("span", { className: cn('badge', config.className, className), children: config.label }));
}
const environmentStatusMap = {
    normal: { label: 'Normal', className: 'bg-green-100 text-green-800' },
    warning: { label: 'Warning', className: 'bg-amber-100 text-amber-800' },
    critical: { label: 'Critical', className: 'bg-red-100 text-red-800' },
    unknown: { label: 'Unknown', className: 'bg-gray-100 text-gray-500' },
};
export function EnvironmentStatusBadge({ status, className }) {
    const config = environmentStatusMap[status] ?? { label: status, className: 'bg-gray-100 text-gray-500' };
    return (_jsx("span", { className: cn('badge', config.className, className), children: config.label }));
}
const conditionGradeMap = {
    excellent: { label: 'Excellent', className: 'bg-green-100 text-green-800' },
    very_good: { label: 'Very Good', className: 'bg-emerald-100 text-emerald-800' },
    good: { label: 'Good', className: 'bg-teal-100 text-teal-800' },
    fair: { label: 'Fair', className: 'bg-amber-100 text-amber-800' },
    poor: { label: 'Poor', className: 'bg-orange-100 text-orange-800' },
    damaged: { label: 'Damaged', className: 'bg-red-100 text-red-800' },
};
export function ConditionGradeBadge({ status, className }) {
    const config = conditionGradeMap[status] ?? { label: status, className: 'bg-gray-100 text-gray-500' };
    return (_jsx("span", { className: cn('badge', config.className, className), children: config.label }));
}
const alertSeverityMap = {
    critical: { label: 'Critical', dotClass: 'bg-red-500' },
    warning: { label: 'Warning', dotClass: 'bg-amber-500' },
    info: { label: 'Info', dotClass: 'bg-blue-500' },
};
export function AlertSeverityBadge({ status, className }) {
    const config = alertSeverityMap[status] ?? { label: status, dotClass: 'bg-gray-400' };
    return (_jsxs("span", { className: cn('inline-flex items-center gap-1.5 text-sm font-medium', className), children: [_jsx("span", { className: cn('h-2 w-2 rounded-full', config.dotClass) }), config.label] }));
}
